import React from "react";
import { PILLAR_META } from "@/data/mera-brands";

// Single source of truth for pillar colors: mera-brands.js.
// Map from the display label used in this component back to the pillar key.
const PILLAR_DOT_COLORS = {
  Memory: PILLAR_META.memory.color,
  Commerce: PILLAR_META.commerce.color,
  Intelligence: PILLAR_META.intelligence.color,
  Governance: PILLAR_META.governance.color,
  Mastery: PILLAR_META.mastery.color,
};

const PILLARS = [
  {
    k: "Memory",
    v: "Personal intelligence that holds the thread of who you are.",
  },
  {
    k: "Commerce",
    v: "Billing and operations that treat one person like an enterprise.",
  },
  {
    k: "Intelligence",
    v: "Behavioral and human potential signals that compound over time.",
  },
  {
    k: "Governance",
    v: "The policy and compliance layer that makes AI deployable at scale.",
  },
  {
    k: "Mastery",
    v: "Education infrastructure designed for institutions and outcomes.",
  },
];

export const Ecosystem = () => {
  return (
    <section
      id="ecosystem"
      data-testid="ecosystem-section"
      className="px-6 md:px-10 py-24 md:py-32 border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono-label text-[11px] text-black/55 sticky top-32">
            § 03 · Manifesto
          </div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <p className="font-serif-display text-[28px] md:text-[44px] leading-[1.18] tracking-tight">
            We believe the most valuable technology of the next decade will not
            replace people — it will{" "}
            <span className="italic-accent">
              remember them, account for them, and educate them
            </span>
            . MERA exists to build that quiet infrastructure.
          </p>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 border-t border-black/10 pt-12">
            {PILLARS.map((p, i) => (
              <div key={p.k} data-testid={`pillar-${p.k.toLowerCase()}`}>
                <div className="font-mono-label text-[11px] text-black/55">
                  0{i + 1} / Pillar
                </div>
                <div className="mt-3 flex items-center gap-2.5">
                  <span
                    aria-hidden
                    className="inline-block w-2 h-2 rounded-full shrink-0"
                    style={{ backgroundColor: PILLAR_DOT_COLORS[p.k] }}
                  />
                  <h3 className="font-serif-display text-[26px] leading-tight">
                    {p.k}
                  </h3>
                </div>
                <p className="mt-3 text-[14px] leading-relaxed text-black/65">
                  {p.v}
                </p>
              </div>
            ))}
          </div>

          <p
            data-testid="ecosystem-closing"
            className="mt-14 max-w-[760px] font-serif-display italic text-[22px] md:text-[26px] leading-[1.35] text-black/80"
          >
            These are not five separate ideas. They are five expressions of the
            same belief — that technology should serve the human, not the other
            way around. MERA exists at the intersection of all five.
          </p>
        </div>
      </div>
    </section>
  );
};
